import { ConfigOption } from '@ngx-formly/core';
import { CostBaseDropdownComponent } from './controls/cost-base-dropdown/cost-base-dropdown.component';
import { CostCenterDropdownComponent } from './controls/cost-centre-dropdown/cost-centre-dropdown.component';
import { CostObjectDropdownComponent } from './controls/cost-object-dropdown/cost-object-dropdown.component';

export const COST_TYPES_FORMLY_TYPES: ConfigOption['types'] = [
  { name: 'formly-cost-object-dropdown', component: CostObjectDropdownComponent, wrappers: ['simple-title'], },
  { name: 'formly-cost-centre-dropdown', component: CostCenterDropdownComponent, wrappers: ['simple-title'], },
  { name: 'formly-cost-base-dropdown', component: CostBaseDropdownComponent, wrappers: ['simple-title'], },
]
